import { Injectable } from '@angular/core';
import { User } from '../models/user';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { FilterUser } from '../models/filters/filter-user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  private users: User[] = [];
  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/users';

  findAllPageableUser(filterUser: FilterUser, page: number, pageSize: number): Observable<any> {
    return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterUser);
  }

  findUserById(id: number): Observable<User> {
    return this.http.get<User>(`${this.url}/${id}`);
  }

  createUser(user: User): Observable<User>{
    return this.http.post<User>(this.url, user);
  }

  updateUser(user: User): Observable<User>{
    return this.http.put<User>(`${this.url}/${user.id}`, user);
  }

  findAllRoles(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/roles`);
  }

  /*remove(id: number): Observable<number>{
    return this.http.delete<number>(`${this.url}/${id}`).pipe(
      map(() => id)
    );
  }*/
  
}
